<template>
	<div>
		<Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
			<template #action>
				<div class="overflow-auto height">
          <SecondaryButton
            text="閉じる"
            class="w-fit block ml-auto my-1 mr-1 px-5"
            @click="closed()"
          >
          </SecondaryButton>

          <div>
            予定を生成したい年月を選択してください。
            <p class="text-red-700">注意！全物件の1ヶ月の予定が生成されます。</p>
            <p class="text-red-700">特定の物件のみの場合は、その物件のマスタ編集画面にて「保存」を押してください。</p>
            <p>管理者権限のみ操作可能です。</p>
          </div>

          <div class="my-3 text-center">
            <input
              type="month"
              v-model="month">
          </div>

          <div class="mx-2 my-3">
            <PrimaryButton
              v-if="!loading"
              text="予定を生成"
              size="normal"
              class="w-full"
              @click="save()"
            />
            <div v-else class="text-lg text-center text-gray-700">生成中...</div>
          </div>
				</div>
			</template>
		</Modal>
	</div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import * as logManager from '@managers/logManager'
import * as dialogs from '@libs/dialogs'
import * as backend from '@libs/backend'
import * as moment from 'moment'

export default {
	components: {
		Modal,
    PrimaryButton,
    SecondaryButton,
	},

	props: {
	},

	data() {
		return {
      loading: false,
      month: moment().format('YYYY-MM')

		}
	},

	methods: {
		/**
		 * 登録処理
		 */
		async save() {
      this.loading = true
      if (!this.month) {
        this.loading = false
        await dialogs.showErrorDialog('対象の年月なし', '年月を選択してください。')
        return
      }

      const m = this.month + '-01'

			// 登録
			try {
        await backend.postData('rls/generateRlsSchedule', { month: m })

				// ログ登録
				logManager.recordingByRegist(
					this,
					false,
					'RLS予定生成',
          `${this.month} のRLS予定1ヶ月分`
				)
        await dialogs.showSuccessDialog('生成完了', '生成完了しました。')
				this.closed()
			} catch (error) {
        this.loading = false
				alert('エラーが発生しました。再度登録してください。\r\n' + error)
			}
		},

		/**
		 * 初期化
		 */
		closed() {
      this.loading = false
      this.month = moment().format('YYYY-MM')
      this.$emit('closed')
		},
	}
}

</script>
<style scoped>
</style>